export const TT_PROVIDER_LINK =
  'https://www.truckertools.com/eld-carrier-integration/?partner=loadsmart'
export const P44_PROVIDER_LINK = 'https://na12.voc.project44.com/portal/v2/public/connect/loadsmart'

export const enum TrackingProvider {
  P44 = 'project-44',
  TT = 'trucker-tools',
  Loadsmart = 'loadsmart',
}

export const enum TrackingMethod {
  API = 'api',
  EDI = 'edi',
  ELD = 'eld',
  Manual = 'manual',
  Mobile = 'mobile',
}

export const ALL_TRACKING_PROVIDERS = [
  TrackingMethod.ELD,
  TrackingMethod.EDI,
  TrackingMethod.API,
  TrackingMethod.Mobile,
  TrackingMethod.Manual,
]
